import { useQuery } from "@tanstack/react-query";
import http from "@/lib/api";

export function useServiceInfo() {
  const { data } = useQuery({
    queryKey: ["service-info"],
    queryFn: () => http.get("/v1/public/service-info").then((r) => r.data),
  });
  return data || null;
}

export const nok = (n) => `${Number(n).toLocaleString("nb-NO")} kr`;

const pkgPrice = (info, id) => {
  const p = info?.packages?.find((x) => x.id === id);
  return p ? nok(p.from_price_nok) : null;
};

// Live values from central service-info; neutral wording when not loaded (e.g. static HTML).
export function liveValues(info) {
  const h = info?.opening_hours;
  return {
    priceA: pkgPrice(info, "A") || "gjeldende pris",
    priceB: pkgPrice(info, "B") || "gjeldende pris",
    priceC: pkgPrice(info, "C") || "gjeldende pris",
    diag: info?.diagnostics?.confirmed_fee_nok ? nok(info.diagnostics.confirmed_fee_nok) : "gjeldende diagnostikkpris",
    hours: h?.man_fre ? `man–fre ${h.man_fre}` : "i åpningstiden",
    hoursWeekday: h?.man_fre || "se gjeldende åpningstider",
    hoursWeekend: h?.lor_son ? h.lor_son.charAt(0).toUpperCase() + h.lor_son.slice(1) : "se gjeldende åpningstider",
    oppmote: info?.transport?.oppmote_nok != null ? nok(info.transport.oppmote_nok) : "et fast oppmøtegebyr",
    perKm: info?.transport?.per_km_nok != null ? `${Number(info.transport.per_km_nok).toLocaleString("nb-NO")} kr` : "en fast sats",
  };
}

export const fill = (text, values) => text.replace(/\{(\w+)\}/g, (m, k) => values[k] ?? m);

export function useLive() {
  return liveValues(useServiceInfo());
}
